import React, { useEffect, useState, useMemo, useCallback } from "react";
import { connect } from "react-redux";
import { format } from "date-fns";
// eslint-disable-next-line no-restricted-imports
import CircularProgress from "@material-ui/core/CircularProgress";

import Editable from "../../partials/content/Table/Editable";
import { getApi, deleteApi, editApi, createApi } from "../../axios/operatorApi";
import axios from "axios";
import {
  fetchOpeartors,
  getOperators,
  createOperator
} from "../../actions/operator";
import {
  Portlet,
  PortletBody,
  PortletHeader
} from "../../partials/content/Portlet";
function Operator(props) {
  const {
    onFetchOperator,
    operators,
    loading,
    getOperators,
    createOperator
  } = props;
  const [data, setData] = useState();
  // const [loading, setLoading] = useState(true);
  console.log("object", operators);

  const fields = React.useMemo(() => [
    { label: "Name", type: "text", name: "name", value: "" },
    { label: "Key", type: "text", name: "key", value: "" },
    { label: "MCC", type: "text", name: "mcc", value: "" },
    { label: "MNC", type: "text", name: "mnc", value: "" }
  ]);

  const columns = React.useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name"
      },
      {
        Header: "Key",
        accessor: "key"
      },

      {
        Header: "MCC",
        accessor: "mcc"
      },

      {
        Header: "MNC",
        accessor: "mnc"
      },

      {
        Header: "CreatedAt",
        accessor: "createdAt",
        Cell: ({ row: { original } }) => {
          return original.created_at === undefined
            ? format(new Date(original.createdAt), "dd-MM-yyyy'T'HH:mm:a")
            : format(new Date(original.created_at), "dd-MM-yyyy'T'HH:mm:a");
        }
      }
    ],
    []
  );

  useEffect(() => {
    onFetchOperator();
  }, []);

  const deleteOperator = id => {
    deleteApi(id);
  };

  const create = data => {
    createOperator(data);
  };

  const updateOperator = (id, data) => {
    editApi(id, data);
  };

  const [skipPageReset, setSkipPageReset] = React.useState(false);
  const updateMyData = (rowIndex, columnId, value) => {
    // We also turn on the flag to not reset the page
    setSkipPageReset(true);
    operators.map((row, index) => {
      if (index === rowIndex) {
        let data = {
          ...operators[rowIndex],
          [columnId]: value
        };

        updateOperator(data._id, data);

        return {
          ...operators[rowIndex],
          [columnId]: value
        };
      }
      return row;
    });
  };
  return (
    <>
      <Portlet fluidHeight={true}>
        <PortletHeader title="Operator" />

        <PortletBody>
          {loading ? (
            <div style={{ margin: "0 auto" }}>
              <CircularProgress />
            </div>
          ) : (
            <Editable
              fields={fields}
              columns={columns}
              data={operators}
              deleteData={deleteOperator}
              createData={create}
              setData={getOperators}
              updateMyData={updateMyData}
              skipPageReset={skipPageReset}
            />
          )}
        </PortletBody>
      </Portlet>
    </>
  );
}

const mapStateToProps = state => ({
  operators: state.operators.operators,
  loading: state.operators.loading
});

const mapDispatchToProps = dispatch => {
  return {
    onFetchOperator: () => dispatch(fetchOpeartors()),
    getOperators: data => dispatch(getOperators(data)),
    createOperator: value => dispatch(createOperator(value))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Operator);
